export class IntegrationDI {
    public static readonly PariPlayConfig: symbol = Symbol('IntegrationDI.PariPlayConfig');
    public static readonly ErrorsHandler: symbol = Symbol('IntegrationDI.ErrorsHandler');
}
